import React from 'react';

// Affiché brièvement pendant le chargement à la demande d'une page (code-splitting, voir App.jsx).
export default function RouteLoading() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#070D1E' }}>
      <div style={{ width: 36, height: 36, borderRadius: '50%', border: '3px solid rgba(59,111,224,.2)', borderTopColor: '#3B6FE0', animation: 'om-spin 0.8s linear infinite' }} />
      <style>{`@keyframes om-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
